import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import UGCTabs from './UGCTabs';

export class UGCTabsContainer extends React.PureComponent {
  render() {
    return <UGCTabs {...this.props} />;
  }
}

UGCTabsContainer.propTypes = {
  summary: ImmutablePropTypes.map
};

const mapStateToProps = state => ({
  summary: selectUgcSummary(state)
});

export default connect(mapStateToProps)(UGCTabsContainer);
